export const getFormattedCitationAnchorId = (id: string, idx = 0) =>
    `citation-anchor-${id}-${idx}`;
export const getFormattedCitationFooterId = (id: string) =>
    `citation-footer-${id}`;
